import { useEffect, useMemo, useState, useContext } from 'react';
import { useRemote } from '../../../Utils/Utils';
import { Search } from 'react-feather';
import { BannerContext } from '../../../InternalApiApp';
import Table from '../../../components/Table/Table';
import LoadingIcon from '../../Shared/LoadingIcon';
import SimpleSearchFilter, { filterBy } from '../../../components/Input/SimpleSearchFilter';
import FlexWrapper from '../../FlexWrapper';
import TruncatedString from '../../Shared/TruncatedString';
import AnalyticsExportButton from './AnalyticsExportButton';
import { analyticsExportFilename } from '../AnalyticsUtils';
import moment from 'moment';


const NavigationPatternsViews = ({ customeDate }) => {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [hasSearchTerm, setHasSearchTerm] = useState("")

    const { bannerAdditionalInfo } = useContext(BannerContext)
    const remote = useRemote();

    useEffect(() => {
        console.log('NavigationPatternsViews useEffect called')
        if (bannerAdditionalInfo && customeDate && customeDate.from && customeDate.to) {
            setLoading(true);

            const end = moment(customeDate.to).format('YYYY-MM-DD');
            const start = moment(customeDate.from).format('YYYY-MM-DD');
            const products = bannerAdditionalInfo?.platforms.map(platform =>
                platform.products.map(p => p.selected ? `product=${p.id}` : null)
                    .filter(e => e !== null)
                    .join("&")
            )

            console.log('products', products)
            const dataPromise = remote.get(`/analytics/aggregates/navigation-patterns/paths?${ !products ? "" : products + "&" }from=${start}&to=${end}`)

            Promise.all([dataPromise]).then(([fetchedData]) => {
                const sortedRankings = fetchedData.length > 0 ? fetchedData.sort((a, b) => b.count - a.count) : [];
                setData(sortedRankings)
                setLoading(false);
            }).catch((error) => {
                console.error('Error fetching navigation patterns data:', error);
                setLoading(false);
            })
        }
    }, [customeDate, bannerAdditionalInfo, remote]);

    const colWidths = ["auto", "auto", "auto", "90px"]
    const headers = [
        {
            text: "First Portfolio",
            className: 'compact-header'
        },
        {
            text: "Second Portfolio",
            className: 'compact-header'
        },
        {
            text: "Third Portfolio",
            className: 'compact-header'
        },
        {
            text: "Count",
            className: 'text-align-right compact-header'
        }
    ]

    function dataMap(data) {
        const mappedData = data && data.map((sequence, idx) => {
            if (idx > 9) return null;
            return (
                <>
                    <tr key={idx} >
                        <td style={{ fontSize: '0.85rem', paddingRight: '1rem' }}><TruncatedString string={sequence.firstPortfolio} /></td>
                        <td style={{ fontSize: '0.85rem', paddingRight: '1rem' }}><TruncatedString string={sequence.secondPortfolio} /></td>
                        <td style={{ fontSize: '0.85rem', paddingRight: '1rem' }}><TruncatedString string={sequence.thirdPortfolio} /></td>
                        <td style={{ fontSize: '0.85rem', textAlign: 'right' }}>{sequence.count}</td>
                    </tr>
                </>
            );
        })
        return mappedData;
    };

    function filter(dataToFilter, searchTerm) {
        if (searchTerm === null || searchTerm.trim().length === 0) {
            return dataToFilter
        }
        return dataToFilter.filter((datum) => filterBy(datum, ["firstPortfolio", "secondPortfolio", "thirdPortfolio"], searchTerm))
    }

    const filteredData = filter(data, hasSearchTerm)
    const dataToDisplay = !!filteredData ? dataMap(filteredData) : null

    const exportHeaders = useMemo(() => [
        { label: 'First Portfolio', key: 'firstPortfolio' },
        { label: 'Second Portfolio', key: 'secondPortfolio' },
        { label: 'Third Portfolio', key: 'thirdPortfolio' },
        { label: 'Count', key: 'count' },
    ], []);

    const exportFilename = useMemo(
        () => analyticsExportFilename('navigation-patterns', customeDate),
        [customeDate]
    );

    return (
        <>
            <FlexWrapper className='mb-s' justify="space-between" align="center" >
                <p className="font-weight-semi-bold">Most Common Transition Path</p>
                <FlexWrapper gap="s">
                    <SimpleSearchFilter
                        placeholder={`Search portfolios`}
                        setSearchTerm={setHasSearchTerm}
                        size="small"
                        width="m"
                        icon={<Search />}
                        searchTerm={hasSearchTerm}
                    />
                    <AnalyticsExportButton headers={exportHeaders} data={data} filename={exportFilename} loading={loading} />
                </FlexWrapper>
            </FlexWrapper>
            {loading
                ? <div style={{ height: 352, display: 'flex' }}><LoadingIcon centered /></div>
                : <Table
                    suggestionMessage
                    suggestionMessageText={"No transitions in this period. Try expanding the timeframe."}
                    smStyle={{ height: 352 }}
                    // height={352}
                    rowSize="s"
                    colWidths={colWidths}
                    headers={headers}
                    dataMap={dataToDisplay} />
            }
        </>
    )
}

export default NavigationPatternsViews